const simonDataIdentifyAndTrack = (email, optIn, eventSource) => {
  // eslint-disable-next-line no-undef
  sd.identify('', { email });

  // eslint-disable-next-line no-undef
  sd.track('registration', {
    email,
    optIn,
    properties: {
      account: 'email',
      thinx_marketing: 'true',
      signup: eventSource,
      dateaddedthinx: new Date().toLocaleDateString(),
      source: eventSource,
    },
  });
};

export default simonDataIdentifyAndTrack;
